import React from 'react';
import { motion } from 'framer-motion';
import { FiChevronDown } from 'react-icons/fi';
import TokenIcon from './TokenIcon';

const TokenSelectButton = ({ token, onClick, disabled, size = 24, style }) => {
  return (
    <motion.button 
      className="token-select-button"
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      style={style}
      aria-label={token ? `Select token: ${token.symbol}` : 'Select token'}
    >
      {token ? (
        <>
          <div className="token-select-icon">
            <TokenIcon token={token} size={size} />
          </div>
          <div className="token-select-info">
            <span className="token-select-symbol">{token.symbol}</span>
            <span className="token-select-name">{token.name}</span>
          </div>
          <FiChevronDown className="token-select-chevron" />
          {token.isMultiChain && (
            <span className="token-select-badge">Multi</span>
          )}
        </>
      ) : (
        <>
          <span className="token-select-placeholder">Select Token</span>
          <FiChevronDown className="token-select-chevron" />
        </>
      )}
    </motion.button>
  );
};

export default TokenSelectButton; 